import React, { useState } from 'react';
import axios from 'axios';
import {
  OrderSearch, OrderDateSelect, useOrderDates, orderDateLabel, sectionStyle, actionButtonStyle,
} from './PastOrderSearch';

// Search every order ever placed for this school (deleted/archived ones
// included) by reference number or name, and copy one onto an order date
// as-is — e.g. bringing back last month's order that was never paid. The
// copy is a new order with its own reference number, unpaid; the original
// is untouched. For a repeat order the admin may want to adjust first (and
// email the parent about), see CopyOrder instead.
function RestoreOrder({ apiBase, onRestored }) {
  const { orderDates, selectedId, setSelectedId, selected, error } = useOrderDates(apiBase);
  const [copyingId, setCopyingId] = useState(null);

  const restore = async (order) => {
    if (!selected) {
      alert('Choose an order date to restore into.');
      return;
    }
    const label = orderDateLabel(selected);
    if (!window.confirm(`Copy ${order.name}'s order (${order.reference_number}) to ${label}?\n\nIt will get a new reference number and start as unpaid.`)) {
      return;
    }
    setCopyingId(order.id);
    try {
      const res = await axios.post(`${apiBase}/orders/${order.id}/copy`, { order_date_id: selected.id });
      alert(`Restored as order ${res.data.reference_number} for ${label}.`);
      onRestored?.();
    } catch (err) {
      alert(err.response?.data?.error || 'Failed to restore order');
    } finally {
      setCopyingId(null);
    }
  };

  return (
    <div style={sectionStyle}>
      <h3 style={{margin: '0 0 0.5rem 0'}}>Restore a Past Order</h3>
      <div style={{fontSize: '0.9rem', color: '#666', marginBottom: '1rem'}}>
        Bring back a past order exactly as it was — usually one that was never paid. Search all orders, including
        deleted ones, by reference number or name. The restored order gets a new reference number and starts unpaid.
      </div>

      <OrderDateSelect
        id="restore-target"
        label="Restore into:"
        orderDates={orderDates}
        value={selectedId}
        onChange={setSelectedId}
      />
      {error && <div style={{color: '#dc3545', marginBottom: '1rem'}}>{error}</div>}

      <OrderSearch
        apiBase={apiBase}
        renderAction={o => (
          <button
            onClick={() => restore(o)}
            disabled={copyingId !== null || !selected}
            style={actionButtonStyle(copyingId !== null)}
          >
            {copyingId === o.id ? 'Restoring...' : 'Restore'}
          </button>
        )}
      />
    </div>
  );
}

export default RestoreOrder;
